/**
 * Version information for the Contexify package
 *
 * This file is automatically updated by the version synchronization system
 * when the package version changes.
 */

/**
 * Current version of the Contexify package
 */
export const VERSION = '1.2.2';
